var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "has-background-dark tile-border" },
    [
      _c(
        "DashboardPanel",
        [
          _c(
            "div",
            {
              staticClass:
                "panel-heading has-text-centered has-text-white custom-panel-heading",
            },
            [_vm._v(" JOB STATUS ")]
          ),
          _c("DashboardProgressBar", {
            attrs: {
              "is-loading": _vm.isLoading,
              "initial-color": "#9057FF",
              "loading-color": "#9d2dba",
            },
          }),
          _vm.quotes
            ? _c("div", { staticClass: "has-background-dark tile-border" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                    class: [
                      {
                        "custom-panel-with-no-chart":
                          _vm.isUninvoicedJobsAndChartDisabled,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onClick(_vm.JobStageTypes.BookedIn)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "is-flex is-align-items-center" }, [
                      _vm._v("Booked In"),
                    ]),
                    _c("DashboardCircularStatus", {
                      attrs: {
                        value: _vm.quotes.bookedIn,
                        "color-code": "#9057FF",
                        width: "50px",
                        height: "50px",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                    class: [
                      {
                        "custom-panel-with-no-chart":
                          _vm.isUninvoicedJobsAndChartDisabled,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onClick(_vm.JobStageTypes.WaitingForParts)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "is-flex is-align-items-center" }, [
                      _vm._v("Waiting On Parts"),
                    ]),
                    _c("DashboardCircularStatus", {
                      attrs: {
                        value: _vm.quotes.waitingForParts,
                        "color-code": "#9057FF",
                        width: "50px",
                        height: "50px",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                    class: [
                      {
                        "custom-panel-with-no-chart":
                          _vm.isUninvoicedJobsAndChartDisabled,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onClick(_vm.JobStageTypes.VehicleArrived)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "is-flex is-align-items-center" }, [
                      _vm._v("Vehicle Arrived"),
                    ]),
                    _c("DashboardCircularStatus", {
                      attrs: {
                        value: _vm.quotes.vehicleArrived,
                        "color-code": "#9057FF",
                        width: "50px",
                        height: "50px",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                    class: [
                      {
                        "custom-panel-with-no-chart":
                          _vm.isUninvoicedJobsAndChartDisabled,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onClick(_vm.JobStageTypes.WorkInProgress)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "is-flex is-align-items-center" }, [
                      _vm._v("Work In Progress"),
                    ]),
                    _c("DashboardCircularStatus", {
                      attrs: {
                        value: _vm.quotes.workInProgress,
                        "color-code": "#9057FF",
                        width: "50px",
                        height: "50px",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                    class: [
                      {
                        "custom-panel-with-no-chart":
                          _vm.isUninvoicedJobsAndChartDisabled,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onClick(_vm.JobStageTypes.VehicleReady)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "is-flex is-align-items-center" }, [
                      _vm._v("Vehicle Ready"),
                    ]),
                    _c("DashboardCircularStatus", {
                      attrs: {
                        value: _vm.quotes.vehicleReady,
                        "color-code": "#9057FF",
                        width: "50px",
                        height: "50px",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                    class: [
                      {
                        "custom-panel-with-no-chart":
                          _vm.isUninvoicedJobsAndChartDisabled,
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onClick(_vm.JobStageTypes.InvoicePending)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "is-flex is-align-items-center" }, [
                      _vm._v("Invoice Pending"),
                    ]),
                    _c("DashboardCircularStatus", {
                      attrs: {
                        value: _vm.quotes.invoicePending,
                        "color-code": "#9057FF",
                        width: "50px",
                        height: "50px",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }